import styled from "styled-components";

const Separator = styled.hr`
  width: 100%;

  border: 0;
  border-top: 1px solid var(--color-grey-300);
`;

export default Separator;
